import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";

// Code-split heavier/less-critical pages so Lighthouse Performance stays high
const Terms = lazy(() => import("@/pages/Terms"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const RefundPolicy = lazy(() => import("@/pages/RefundPolicy"));
const AcceptableUse = lazy(() => import("@/pages/AcceptableUse"));
const Security = lazy(() => import("@/pages/Security"));
const Subprocessors = lazy(() => import("@/pages/Subprocessors"));
const DPA = lazy(() => import("@/pages/DPA"));
const Trust = lazy(() => import("@/pages/Trust"));
const ResponsibleUse = lazy(() => import("@/pages/ResponsibleUse"));
const AiPolicy = lazy(() => import("@/pages/AiPolicy"));
const DataHandling = lazy(() => import("@/pages/DataHandling"));
const PlatformIndependence = lazy(() => import("@/pages/PlatformIndependence"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function PageFallback() {
  return (
    <div className="lulo-container py-24" aria-busy="true">
      <div className="h-8 w-1/3 rounded bg-slate-100 animate-pulse" />
      <div className="mt-4 h-4 w-2/3 rounded bg-slate-100 animate-pulse" />
      <div className="mt-2 h-4 w-1/2 rounded bg-slate-100 animate-pulse" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/terms"
            element={
              <Suspense fallback={<PageFallback />}>
                <Terms />
              </Suspense>
            }
          />
          <Route
            path="/privacy"
            element={
              <Suspense fallback={<PageFallback />}>
                <Privacy />
              </Suspense>
            }
          />
          <Route
            path="/refund-policy"
            element={
              <Suspense fallback={<PageFallback />}>
                <RefundPolicy />
              </Suspense>
            }
          />
          <Route
            path="/acceptable-use"
            element={
              <Suspense fallback={<PageFallback />}>
                <AcceptableUse />
              </Suspense>
            }
          />
          <Route
            path="/security"
            element={
              <Suspense fallback={<PageFallback />}>
                <Security />
              </Suspense>
            }
          />
          <Route
            path="/subprocessors"
            element={
              <Suspense fallback={<PageFallback />}>
                <Subprocessors />
              </Suspense>
            }
          />
          <Route
            path="/dpa"
            element={
              <Suspense fallback={<PageFallback />}>
                <DPA />
              </Suspense>
            }
          />
          <Route
            path="/trust"
            element={
              <Suspense fallback={<PageFallback />}>
                <Trust />
              </Suspense>
            }
          />
          <Route
            path="/responsible-use"
            element={
              <Suspense fallback={<PageFallback />}>
                <ResponsibleUse />
              </Suspense>
            }
          />
          <Route
            path="/ai-policy"
            element={
              <Suspense fallback={<PageFallback />}>
                <AiPolicy />
              </Suspense>
            }
          />
          <Route
            path="/data-handling"
            element={
              <Suspense fallback={<PageFallback />}>
                <DataHandling />
              </Suspense>
            }
          />
          <Route
            path="/platform-independence"
            element={
              <Suspense fallback={<PageFallback />}>
                <PlatformIndependence />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={<PageFallback />}>
                <NotFound />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
